import { generateUniqueId } from 'seagull/utils/generateUniqueId';
import { BillingType, BillMode, InitialDiscount, ServiceFormDataType } from '~/components/BillClientModal/BillClientModal.types';
import { discountToDTO } from '~/components/BillClientModal/BillClientModal.utils';
import { serviceCostModel } from '~/models';
import { QboIntegrationLineItemType } from '~/models/integration/model';
import { toDatestampString } from '~/models/time';
import { BillingScheduleType } from '~/types/api/billing/submit-charges';
import { utils } from '~/utils';
export function createEmptyServiceItem(service) {
    return {
        itemId: generateUniqueId('service'),
        type: BillingType.Service,
        note: '',
        service: {
            type: ServiceFormDataType.Default,
            id: service.id,
            price: '',
            quantity: '',
            cost: service.cost
        },
        fullService: service
    };
}
export const billingStagesTextsPath = 'billing.stages';
export const getStageNote = (param)=>{
    let { stageNumber, stagesLength, t } = param;
    return t.stageNote({
        stageNumber,
        totalStages: stagesLength
    });
};
export function createServiceItemWithStages(param) {
    let { service, stageNumber, billingStages, note } = param;
    return {
        itemId: generateUniqueId('service'),
        type: BillingType.Service,
        note: note || '',
        service: {
            type: ServiceFormDataType.Stages,
            id: service.id,
            price: '',
            quantity: '',
            cost: service.cost,
            stageNumber,
            billingStages
        },
        fullService: service
    };
}
export function convertTimeToQuantityInHours(param) {
    let { hours, minutes } = param;
    return +(hours + minutes / 60).toFixed(2);
}
export function createTimeActivityServiceItem(service, timeActivity) {
    return {
        itemId: generateUniqueId('service'),
        timeActivityId: timeActivity.id,
        type: BillingType.Service,
        note: timeActivity.note,
        service: {
            type: ServiceFormDataType.Default,
            id: service.id,
            price: serviceCostModel.isVariablePrice(service.cost) ? utils.formatDollarAmount(serviceCostModel.price(service.cost)) : '',
            quantity: convertTimeToQuantityInHours({
                hours: timeActivity.hours,
                minutes: timeActivity.minutes
            }).toString(),
            cost: service.cost
        },
        fullService: service
    };
}
export function createEmptyChargeItem() {
    return {
        itemId: generateUniqueId('charge'),
        type: BillingType.Charge,
        note: '',
        charge: {
            serviceTemplateId: '',
            quantity: '',
            rate: '',
            discount: InitialDiscount
        }
    };
}
export const mapItemToCharge = (item)=>{
    const { serviceTemplateId, rate, quantity, discount } = item.charge;
    const note = item.note;
    if (!serviceTemplateId) {
        throw new Error('Service is required');
    }
    return {
        serviceTemplateId,
        note: note || undefined,
        rate: rate,
        quantity: quantity,
        discount: discountToDTO(discount)
    };
};
export const mapItemToService = (item, timeActivity)=>{
    const { id, quantity, cost, price } = item.service;
    const { note } = item;
    return {
        serviceId: id,
        quantity: serviceCostModel.isVariablePrice(cost) ? quantity : undefined,
        price: serviceCostModel.isRangePrice(cost) ? price : undefined,
        note: note || undefined,
        stageNumber: item.service.type === ServiceFormDataType.Stages ? item.service.stageNumber : undefined,
        integrations: timeActivity ? [
            {
                type: QboIntegrationLineItemType.QBO,
                value: {
                    timeActivity
                }
            }
        ] : undefined
    };
};
export const getSubmitChargesData = (data, timeActivities, attachments)=>{
    const { issueDate, items, mode } = data;
    const outOfScopeCharges = items.filter((item)=>item.type === BillingType.Charge).map((item)=>mapItemToCharge(item));
    const servicesListedInAgreement = items.filter((item)=>item.type === BillingType.Service).map((item)=>{
        const timeActivity = item.timeActivityId ? timeActivities === null || timeActivities === void 0 ? void 0 : timeActivities.getTimeActivitiesForService(item.service.id).find((ta)=>ta.id === item.timeActivityId) : undefined;
        return mapItemToService(item, timeActivity);
    });
    const shortDate = toDatestampString(issueDate);
    return {
        outOfScopeCharges,
        servicesListedInAgreement,
        billingDetails: {
            issueDate: shortDate,
            type: mode === BillMode.Now ? BillingScheduleType.BillNow : BillingScheduleType.ScheduleBill
        },
        attachments
    };
};
